<template>
  <footer class="c-footer">
    <nav>
      <ul class="c-footer__nav">
        <li>
          <a href="https://www.hoosiers.co.jp/privacypolicy/" target="_blank"
            >プライバシーポリシー</a
          >
        </li>
        <li>
          <a href="/mc/docs/kiyaku.html" target="_blank">利用規約</a>
        </li>
        <li>
          <router-link
            :to="{
              name: 'in-contact',
              params: { mc_code: mcCode },
            }"
          >
            お問い合わせ
          </router-link>
        </li>
        <li>
          <router-link
            :to="{
              name: 'mypage',
              params: { mc_code: mcCode },
            }"
          >
            ユーザー情報
          </router-link>
        </li>
      </ul>
    </nav>
    <p class="c-footer__copyrights">
      © Hoosiers Holdings Co., Ltd. ALL RIGHTS RESERVED.
    </p>
    <!-- <p v-if="currentUser.status == 'contractor'">
            ITOCHU HOUSING,
          </p> -->
  </footer>
</template>

<script>
export default {};
</script>

<style></style>
